module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 offset-md-4 login-form mx-auto p-5"
  }, [_c('div', {
    staticClass: "p-3"
  }, [(_vm.locale === 'cn') ? _c('img', {
    attrs: {
      "src": require("../assets/image/logo_L_size(china).png"),
      "width": "100%"
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/image/logo_L_size.png"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-12': true, 'col-md-8': _vm.is_enable_ischool
    }
  }, [_c('form', {
    class: {
      'form-custom': true, 'border-right': _vm.is_enable_ischool
    },
    staticStyle: {
      "min-width": "auto"
    }
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v(_vm._s(_vm.$t('username')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    staticClass: "form-control rounded",
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('username'),
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v(_vm._s(_vm.$t('password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control mt-3 rounded",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('password'),
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary btn-block mt-5",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.login()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('login')))])])]), _vm._v(" "), (_vm.is_enable_ischool) ? _c('div', {
    class: {
      'col-12': true, ' col-md-4': _vm.is_enable_ischool
    }
  }, [_c('button', {
    staticClass: "btn btn-lg btn-primary btn-block mt-3",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.openISchoolUrl()
      }
    }
  }, [_vm._v("iSchool " + _vm._s(_vm.$t('login')))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1dce21ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 713
// module chunks = 1